/**
 * Country to flag emoji mapping for aircraft registration countries
 * Based on ICAO aircraft registration prefixes
 */

export const COUNTRY_FLAGS: Record<string, string> = {
  // North America
  "United States": "🇺🇸",
  "Canada": "🇨🇦",
  "Mexico": "🇲🇽",

  // South America
  "Brazil": "🇧🇷",
  "Argentina": "🇦🇷",
  "Chile": "🇨🇱",
  "Colombia": "🇨🇴",
  "Ecuador": "🇪🇨",
  "Peru": "🇵🇪",
  "Venezuela": "🇻🇪",

  // Central America & Caribbean
  "Panama": "🇵🇦",
  "El Salvador": "🇸🇻",
  "Guatemala": "🇬🇹",
  "Honduras": "🇭🇳",
  "Costa Rica": "🇨🇷",
  "Nicaragua": "🇳🇮",
  "Jamaica": "🇯🇲",
  "Dominican Republic": "🇩🇴",

  // Europe
  "United Kingdom": "🇬🇧",
  "Germany": "🇩🇪",
  "France": "🇫🇷",
  "Italy": "🇮🇹",
  "Spain": "🇪🇸",
  "Portugal": "🇵🇹",
  "Netherlands": "🇳🇱",
  "Belgium": "🇧🇪",
  "Switzerland": "🇨🇭",
  "Austria": "🇦🇹",
  "Sweden": "🇸🇪",
  "Norway": "🇳🇴",
  "Denmark": "🇩🇰",
  "Finland": "🇫🇮",
  "Ireland": "🇮🇪",
  "Poland": "🇵🇱",
  "Czech Republic": "🇨🇿",
  "Hungary": "🇭🇺",
  "Russia": "🇷🇺",
  "Ukraine": "🇺🇦",
  "Bulgaria": "🇧🇬",
  "Romania": "🇷🇴",
  "Greece": "🇬🇷",
  "Malta": "🇲🇹",

  // Asia Pacific
  "Australia": "🇦🇺",
  "New Zealand": "🇳🇿",
  "Japan": "🇯🇵",
  "South Korea": "🇰🇷",
  "China": "🇨🇳",
  "India": "🇮🇳",
  "Malaysia": "🇲🇾",
  "Singapore": "🇸🇬",
  "Thailand": "🇹🇭",
  "Indonesia": "🇮🇩",
  "Philippines": "🇵🇭",
  "Vietnam": "🇻🇳",

  // Middle East
  "United Arab Emirates": "🇦🇪",
  "Saudi Arabia": "🇸🇦",
  "Iran": "🇮🇷",
  "Turkey": "🇹🇷",
  "Israel": "🇮🇱",
  "Jordan": "🇯🇴",
  "Oman": "🇴🇲",
  "Qatar": "🇶🇦",
  "Bahrain": "🇧🇭",

  // Africa
  "South Africa": "🇿🇦",
  "Kenya": "🇰🇪",
  "Ethiopia": "🇪🇹",
  "Egypt": "🇪🇬",
  "Morocco": "🇲🇦",
  "Ivory Coast": "🇨🇮",
  "Nigeria": "🇳🇬",
};

/**
 * Get flag emoji for a country name
 * @param country Country name (e.g., "United States", "Canada")
 * @returns Flag emoji or default flag
 */
export const getCountryFlag = (country: string): string => {
  return COUNTRY_FLAGS[country] || "🏳️";
};

/**
 * Format country display with flag and prefix
 * @param country Country name
 * @param prefix Registration prefix (e.g., "N", "C-", "VH-")
 * @returns Formatted string like "🇺🇸 United States (N)"
 */
export const formatCountryOption = (country: string, prefix: string): string => {
  return `${getCountryFlag(country)} ${country} (${prefix})`;
};
